export default function parse(string){
	return JSON.parse(string.trim().replace(/[\n\t]|,(?=\s*])/g, ''))
}